window.Products.HomeDecor.BedPillowSleeve = function() {};
window.Products.HomeDecor.BedPillowSleeve.inherits(window.Products.HomeDecor.HomeDecor);
window.Products.HomeDecor.BedPillowSleeve.id = 90;
window.Products.HomeDecor.BedPillowSleeve.slug = 'bed-pillow-sleeve';
window.Products.HomeDecor.BedPillowSleeve.has_3d = true;
window.Products.HomeDecor.BedPillowSleeve.has_subproducts = true;
window.Products.HomeDecor.BedPillowSleeve.use_glb = true;
window.Products.HomeDecor.BedPillowSleeve.prototype.designObject = 0;

window.Products.HomeDecor.BedPillowSleeve.prototype.set3dProperties = function(modelViewer) {
	var me = this;

	modelViewer.initalCameraPosition.z = -5;
	modelViewer.setFixedView('front');

	me.loadEnvMap(function(){
		for(var i = 0; i < modelViewer.object.children.length; i++){
			if(!modelViewer.object.children[i].material) continue;
			modelViewer.object.children[i].material.envMap = me.envMap;
			modelViewer.object.children[i].material.envMap.mapping = THREE.EquirectangularReflectionMapping;
			modelViewer.object.children[i].material.needsUpdate = true;
			modelViewer.object.children[i].material.envMap.needsUpdate = true;
		}

		me.updateThreeTexture(modelViewer);
	});
};

window.Products.HomeDecor.BedPillowSleeve.prototype.setThreeControls = function(controls) {
	controls.minDistance = 3.0;
	controls.maxDistance = 5.0;
};

window.Products.HomeDecor.BedPillowSleeve.prototype.updateThreeTexture = function(modelViewer) {
	modelViewer.object.children[1].children[this.designObject].material.map = modelViewer.texture;
	modelViewer.object.children[1].children[this.designObject].material.map.flipY = false;
	modelViewer.object.children[1].children[this.designObject].material.needsUpdate = true;
};